import { render } from "./InvoiceStatusChart.vue?vue&type=template&id=5dae7144&scoped=true"
import script from "./InvoiceStatusChart.vue?vue&type=script&lang=js"
export * from "./InvoiceStatusChart.vue?vue&type=script&lang=js"

import "./InvoiceStatusChart.vue?vue&type=style&index=0&id=5dae7144&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5dae7144"]])

export default __exports__